/* eslint-disable @typescript-eslint/no-unused-vars */
import { merge } from 'lodash';
import moment from 'moment';

/* eslint-disable @typescript-eslint/no-explicit-any */
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import {
  ColDef,
  ColumnMovedEvent,
  ColumnResizedEvent,
  ColumnState,
  ColumnVisibleEvent,
  GridApi,
  GridOptions,
  GridReadyEvent,
  ICellRendererParams,
  RowClassParams,
  RowClickedEvent,
  RowDoubleClickedEvent,
  RowNode, IRowNode,
  SortChangedEvent,
  SuppressKeyboardEventParams,
  ValueFormatterParams,
  ValueGetterParams,
} from '@ag-grid-community/core';
import { ClipboardModule } from '@ag-grid-enterprise/clipboard';
import { ColumnsToolPanelModule } from '@ag-grid-enterprise/column-tool-panel';
import { RowGroupingModule } from '@ag-grid-enterprise/row-grouping';
import { ServerSideRowModelModule } from '@ag-grid-enterprise/server-side-row-model';
import { CurrencyPipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import {
  DataGridAction,
  getAllFocusableElementsOf,
  getEventPath,
} from '@ideapa/app-common';
import { Precision, SelectItem } from '@ideapa/common-interfaces';
import { decimalFormatter } from '@ideapa/common-utils';

import { CustomGridFilterComponent } from '../custom-grid-filter.component';
import { DataGridActionParamsDataInterface } from './data-grid-action-params-data-interface';
import { DataGridActionRenderer } from './data-grid-action-renderer.component';

@Component({
  standalone: false,
  selector: 'ideapa-data-grid',
  templateUrl: './data-grid.component.html',
  styleUrls: ['./data-grid.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [CurrencyPipe],
})
export class DataGridComponent implements OnInit {
  @Input()
  canEdit? = false;

  @Input()
  canDelete? = false;

  @Input()
  canView? = false;

  @Input()
  gridOptions?: GridOptions;

  actions!: DataGridAction[];

  private _hideCommands = false;
  get hideCommands(): boolean {
    return this._hideCommands;
  }
  @Input() set hideCommands(value: boolean) {
    this._hideCommands = value;
    this.setGridColumns(this._prevColumnDefs || []);
  }

  @Input()
  rowSelection?: 'single' | 'multiple';

  @Input()
  floatingFiltersHeight!: number;

  // private _selectedRow = undefined;
  // get selectedRow() {
  //   return this._selectedRow;
  // }
  // @Input()
  // set selectedRow(value: any) {
  //   this._selectedRow = value;

  //   this.gridApi?.getRowNode(value.id)?.setSelected(true);
  // }

  private _canSelect = false;
  get canSelect() {
    return this._canSelect;
  }
  @Input()
  set canSelect(value: boolean) {
    this._canSelect = value;
    this.rowSelection = value ? 'multiple' : 'single';
  }

  private _selectedItems: any[] = [];
  get selectedItems() {
    return this._selectedItems;
  }
  @Input()
  set selectedItems(values: any[]) {
    this._selectedItems = values;
    this.setSelectedItems();
  }

  internalGridOptions!: GridOptions;

  private _columnDefs?: ColDef[];
  private _prevColumnDefs?: ColDef[];
  get columnDefs(): ColDef[] | undefined {
    return this._columnDefs;
  }
  @Input() set columnDefs(value: ColDef[] | undefined) {
    // controlla nomi colonne
    const setGridColumns = this.checkColumnsHeaderName(value);
    // if (JSON.stringify(this._prevColumnDefs) !== JSON.stringify(value)) {
    if (setGridColumns) {
      this._prevColumnDefs = value;
      this.setGridColumns(value || []);
    }
  }

  // @Input()
  // items: any[] = [];
  private _items: any[] = [];
  get items() {
    return this._items;
  }
  @Input()
  set items(values: any[]) {
    this._items = values;
    this.setSelectedItems();
  }

  private _loading = false;
  get loading() {
    return this._loading;
  }
  @Input()
  set loading(value: boolean) {
    this._loading = value;
    if (value) {
      this.gridApi?.showLoadingOverlay();
    } else {
      this.gridApi?.hideOverlay();
    }
  }

  @Input()
  showColumnsSidebar = true;

  @Input()
  customActions?: DataGridAction[] = [];

  @Output()
  add: EventEmitter<void> = new EventEmitter<void>();

  @Output()
  download: EventEmitter<void> = new EventEmitter<void>();

  @Output()
  edit = new EventEmitter<any>();

  @Output()
  view = new EventEmitter<any>();

  @Output()
  delete = new EventEmitter<any>();

  @Output()
  selected = new EventEmitter<any[]>();

  @Output()
  columnStateChanged = new EventEmitter<ColumnState[]>();

  @Output()
  rowClicked = new EventEmitter<any>();

  @Output()
  rowDoubleClicked = new EventEmitter<any>();

  modules = [
    RowGroupingModule,
    ClientSideRowModelModule,
    ColumnsToolPanelModule,
    ServerSideRowModelModule,
    ClipboardModule,
  ];

  gridApi?: GridApi;


  constructor(
    private currencyPipe: CurrencyPipe,
    private cd: ChangeDetectorRef
  ) {}

  getPrecisionParams = (precision?: Precision): Precision => {
    const defaultParams = {
      minimumFractionDigits: 2,
      maximumFractionDigits: 8,
    };
    const {
      minimumFractionDigits = defaultParams.minimumFractionDigits,
      maximumFractionDigits = defaultParams.maximumFractionDigits,
    } = precision || {};
    return { minimumFractionDigits, maximumFractionDigits };
  };

  ngOnInit(): void {
    const commonGridOptions: GridOptions = {
      overlayNoRowsTemplate: '<span>Nessun risultato</span>',
      rowHeight: 30,
      suppressCellFocus: false,
      // enableCellTextSelection: true,
      ensureDomOrder: true,
      rowSelection: this.rowSelection,
      sideBar: this.showColumnsSidebar
        ? {
            toolPanels: [
              {
                id: 'columns',
                labelDefault: 'Colonne',
                labelKey: 'columns',
                iconKey: 'columns',
                toolPanel: 'agColumnsToolPanel',
                toolPanelParams: {
                  suppressPivotMode: true,
                  suppressRowGroups: true,
                  suppressValues: true,
                },
              },
            ],
          }
        : undefined,
      onGridReady: (e: GridReadyEvent) => this.onGridReady(e),
      onSortChanged: (e: SortChangedEvent) => this.onColumnStateChanged(e),
      onColumnVisible: (e: ColumnVisibleEvent) => this.onColumnStateChanged(e),
      onColumnMoved: (e: ColumnMovedEvent) => this.onColumnStateChanged(e),
      onColumnResized: (e: ColumnResizedEvent) => this.onColumnStateChanged(e),
      defaultColDef: {
        editable: false,
        enablePivot: false,
        enableValue: false,
        sortable: true,
        resizable: true,
        flex: 1,
        // minWidth: 200,
        suppressHeaderMenuButton: true,
      },
      components: {
        gridComponentBooleanRenderer: this.gridComponentBooleanRenderer,
        gridComponentEnumRenderer: this.gridComponentEnumRenderer,
        customGridActionRenderer: DataGridActionRenderer,
        customGridFilter: CustomGridFilterComponent,
      },
      columnTypes: {
        boolColumn: {
          cellRenderer: 'gridComponentBooleanRenderer',
        },
        numberColumn: {
          filter: 'agNumberColumnFilter',
        },
        // togliere € e allineare a dx
        currencyColumn: {
          filter: 'agNumberColumnFilter',
          valueFormatter: (params: ValueFormatterParams) => {
            if (params.value == null) {
              return '';
            }
            return this.currencyPipe.transform(params.value + '', ' ') || '';
            // return (
            //   '€ ' + this.currencyPipe.transform(params.value + '', ' ') || ''
            // );
          },
        },
        percentColumn: {
          filter: 'agNumberColumnFilter',
          valueFormatter: (params: ValueFormatterParams<any, number>) => {
            // undefined or null
            if (params.value === undefined || params.value === null) return '';

            // Not a number
            if (typeof params.value !== 'number') return '';

            const precision: Precision | undefined =
              params.column.getUserProvidedColDef()?.cellRendererParams
                ?.precision;

            const value = decimalFormatter(
              this.getPrecisionParams(precision)
            ).format(params.value);

            return value;
          },
        },
        enumColumn: {
          cellRenderer: 'gridComponentEnumRenderer',
        },
        dateColumn: {
          // filter: 'agDateColumnFilter',
          valueFormatter: (params: ValueFormatterParams) => {
            if (!params.value) {
              return '';
            }
            return moment(params.value).format('L');
          },
          valueGetter: (params: ValueGetterParams) => {
            const field = params.colDef.field as string;
            const data = field
              .split('.')
              .reduce((p, c) => (p && p[c]) || null, params.data);
            if (data) {
              return new Date(data);
            } else {
              return null;
            }
          },
          tooltipValueGetter: (params) => {
            if (!params.value) {
              return '';
            }
            return moment(params.value).format('L');
          },
        },
        datetimeColumn: {
          filter: 'agDateColumnFilter',
          valueFormatter: (params: ValueFormatterParams) => {
            if (!params.value) {
              return '';
            }
            return moment(params.value).format('DD/MM/YYYY HH:mm');
          },
          valueGetter: (params: ValueGetterParams) => {
            const field = params.colDef.field as string;
            const data = field
              .split('.')
              .reduce((p, c) => (p && p[c]) || null, params.data);
            if (data) {
              return moment(data).toDate();
            } else {
              return null;
            }
          },
          tooltipValueGetter: (params) => {
            if (!params.value) {
              return '';
            }
            return moment(params.value).format('LLL');
          },
        },
        actionColumn: {
          cellRenderer: 'customGridActionRenderer',
        },
      },
      getRowStyle: /*this.rowSelection
        ? undefined
        :*/ (params: RowClassParams) => {
        if (params.data && params.data.isValid === false) {
          return { background: '#FFE5F2' };
        }
        if (params.node.rowIndex) {
          if (params.node.rowIndex % 2 === 0) {
            return { background: '#ffffff' };
          }
          return { background: '#fcfcfc' };
        }
        return { background: '#ffffff' };
      },
      getRowId: (param) => String(param.data.id),
    };

    if (this.gridOptions) {
      this.internalGridOptions = merge(commonGridOptions, {
        ...this.gridOptions,
        onGridReady: (e: GridReadyEvent) => {
          this.onGridReady(e);
          if (this.gridOptions?.onGridReady) {
            this.gridOptions.onGridReady(e);
          }
        },
      });
    } else {
      this.internalGridOptions = commonGridOptions;
    }

    this.initActions();
  }

  onGridReady(event: GridReadyEvent) {
    //this.gridApi = event.api;

    // console.log('onGridReady');
    // if (this.actions.length > 0) {
    //   this.columnApi.autoSizeColumn('actions');
    // }
    this.gridApi = event.api;
    // console.log(`**this.gridApi: ${this.gridApi}`);
    this.setSelectedItems();
    if (this.loading) {
      this.gridApi?.showLoadingOverlay();
    } else {
      this.gridApi?.hideOverlay();
    }
  }

  gridComponentBooleanRenderer(params: ICellRendererParams) {
    const value = params.value;
    let template = `<div class="d-flex align-items-center h-100">`;
    if (value) {
      template += `Sì`;
      // <i class="material-icons" data-action-type="check">check</i>
    } else {
      template += `No`;
      // template += `<i class="material-icons" data-action-type="close">close</i>`;
    }
    return template + '</div>';
  }

  gridComponentEnumRenderer(
    params: ICellRendererParams & { elementValues: SelectItem[] }
  ) {
    const value = params.value;

    let template = `<div class="d-flex align-items-center h-100">`;
    if (value != null) {
      if (
        params.elementValues != undefined &&
        params.elementValues.length > 0
      ) {
        template += params.elementValues.find(
          (e) => e.value === value
        )?.description;
      } else {
        template += value;
      }
      // <i class="material-icons" data-action-type="check">check</i>
    }
    return template + '</div>';
  }

  private initActions() {
    this.actions = [];

    this.actions.push({
      description: 'modifica',
      icon: 'edit',
      class: 'text-primary',
      //class: 'mdi mdi-pencil',
      onAction: (entity: any) => {
        this.edit.emit(entity);
      },
      visible: (entity: DataGridActionParamsDataInterface) => {
        const isLocked = entity.locked ?? false;
        const isEntityIdValid = entity.id > 0;
        const canEdit = this.canEdit ?? false;
        const isVisible = !isLocked && isEntityIdValid && canEdit;
        return isVisible;
      },
    });
    this.actions.push({
      description: 'visualizza',
      icon: 'visibility',
      class: 'text-primary',
      onAction: (entity: any) => {
        this.view.emit(entity);
      },
      visible: (entity: DataGridActionParamsDataInterface) => {
        const isLocked = entity.locked ?? false;
        const isEntityIdValid = entity.id > 0;
        const canView = this.canView ?? true;
        const canEdit = this.canEdit ?? false;
        const isVisible = !isLocked && isEntityIdValid && canView && !canEdit;
        return isVisible;
      },
    });
    this.actions.push({
      description: 'elimina',
      icon: 'delete',
      class: 'text-danger',
      onAction: (entity: any) => {
        this.delete.emit(entity);
      },
      visible: (entity: DataGridActionParamsDataInterface) => {
        const isLocked = entity.locked ?? false;
        const isEntityIdValid = entity.id > 0;
        const canDelete = this.canDelete ?? false;
        const isVisible = !isLocked && isEntityIdValid && canDelete;
        return isVisible;
      },
    });

    this.actions.push(...(this.customActions ?? []));
  }

  onSelectionChanged(event: any) {
    //SelectionChangedEvent
    const selectedRow = this.gridApi?.getSelectedNodes() || [];
    if (this.selected) {
      this.selected.emit(selectedRow.map((r: IRowNode<any>) => r.data));
    }
  }

  setSelectedItems() {
    this.gridApi?.forEachNode((rn) => {
      const selected = !!this._selectedItems.find((v) => v.id === rn.data.id);
      rn.setSelected(selected);
    });
  }

  onRowDataChanged(data: any) {
    this.setSelectedItems();
  }

  onColumnStateChanged(
    e:
      | SortChangedEvent
      | ColumnVisibleEvent
      | ColumnMovedEvent
      | ColumnResizedEvent
  ) {
    this.columnStateChanged.emit(e.api.getColumnState());
  }

  rowClickedChanged(event: RowClickedEvent) {
    if (this.rowClicked) {
      this.rowClicked.emit(event.data);
    }
  }

  rowDoubleClickedChanged(event: RowDoubleClickedEvent) {
    if (this.rowDoubleClicked) {
      // this.view.emit(event.data);
      this.rowDoubleClicked.emit(event.data);
    }
  }

  setGridColumns(columnDefs: ColDef[]) {
    const columnDefs2 = [...columnDefs];
    if (this.canSelect) {
      columnDefs2.splice(0, 0, {
        colId: 'selection',
        headerCheckboxSelection: true,
        checkboxSelection: true,
        pinned: 'left',
        width: 30,
        filter: false,
        sortable: false,
        resizable: false,
        minWidth: 0,
        suppressMovable: true,
        suppressColumnsToolPanel: true,
        flex: 0,
      });
    }
    if (!this.hideCommands) {
      columnDefs2.push({
        colId: 'actions',
        pinned: 'right',
        width: 10,
        type: 'actionColumn',
        cellRendererParams: {
          context: this,
        },
        filter: false,
        sortable: false,
        resizable: false,
        minWidth: 0,
        suppressMovable: true,
        suppressColumnsToolPanel: true,
        flex: 0,
        suppressSizeToFit: true,
        suppressKeyboardEvent: ({
          event,
          api,
        }: SuppressKeyboardEventParams<any>) => {
          const { key, shiftKey } = event;
          const path = getEventPath(event);
          const isTabForward = key === 'Tab' && shiftKey === false;
          const isTabBackward = key === 'Tab' && shiftKey === true;
          let suppressEvent = false;
          // Handle cell children tabbing
          if (isTabForward || isTabBackward) {
            const eGridCell = path.find((el) => {
              if (el.classList === undefined) return false;
              return el.classList.contains('ag-cell');
            });
            if (!eGridCell) {
              return suppressEvent;
            }
            const focusableChildrenElements =
              getAllFocusableElementsOf(eGridCell);
            const lastCellChildEl =
              focusableChildrenElements[focusableChildrenElements.length - 1];
            const firstCellChildEl = focusableChildrenElements[0];
            // Suppress keyboard event if tabbing forward within the cell and the current focused element is not the last child
            if (isTabForward && focusableChildrenElements.length > 0) {
              const isLastChildFocused =
                lastCellChildEl && document.activeElement === lastCellChildEl;
              if (!isLastChildFocused) {
                suppressEvent = true;
              }
            }
            // Suppress keyboard event if tabbing backwards within the cell, and the current focused element is not the first child
            else if (isTabBackward && focusableChildrenElements.length > 0) {
              const cellHasFocusedChildren =
                eGridCell.contains(document.activeElement) &&
                eGridCell !== document.activeElement;
              // Manually set focus to the last child element if cell doesn't have focused children
              if (!cellHasFocusedChildren) {
                lastCellChildEl.focus();
                // Cancel keyboard press, so that it doesn't focus on the last child and then pass through the keyboard press to
                // move to the 2nd last child element
                event.preventDefault();
              }
              const isFirstChildFocused =
                firstCellChildEl && document.activeElement === firstCellChildEl;
              if (!isFirstChildFocused) {
                suppressEvent = true;
              }
            }
          }
          return suppressEvent;
        },
      } as ColDef);
    }

    this._columnDefs = columnDefs2;
    // this.gridApi?.setColumnDefs(columnDefs);
  }

  checkColumnsHeaderName(value: ColDef[] | undefined) {
    const a = value?.map((c) => c.headerName);
    const b = this._prevColumnDefs?.map((c) => c.headerName);
    return JSON.stringify(a) !== JSON.stringify(b);
  }
}
